/* eslint-disable no-console */

export default {
  name: 'app',
  components: {
    // Content,
  },

  data() {
    return {
      appIcon: require("../../assets/app-icon.png"),
      appName: "Dodo Pizza",
      header: "Title",
      messageCleaned: "Message",
      // message: "Some message",
      iphones: ["SE", "X", "8 Plus"]
    }
  },

  computed: {
    message: {
      set: function (message) {
        this.messageCleaned = this.enableTypo ? tp.execute(message) : message;
        // If necessary, also copy val into an external variable here
      },
      get: function () {
        return this.messageCleaned
      }
    }
  },

  methods: {
    uploadFile(input) {
      if (!input.files || !input.files[0]) return;

      const reader = new FileReader();
      reader.onload = ({target}) => this.appIcon = target.result;
      reader.readAsDataURL(input.files[0]);
    },

    updateMessage() {
      this.message = this.messageCleaned;
    }
  },

  mounted() {
  }
}